if (!document.body.classList.contains('password')) {
  window.addEventListener('klaviyoForms', (e) => {
    if (e.detail.formId == window.newsletter.modalId) {
      if (e.detail.type == 'open') {
        setCookie('hidden_klaviyo_modal', true, 5)
      }
      // This can hide the SMS modal while user is using it (since email one is submitted first)
      // if (e.detail.type == 'submit') {
      //   const closeButton = document.querySelector(
      //     '.klaviyo-close-form'
      //   )

      //   if (closeButton) {
      //     setTimeout(() => {
      //       closeButton.click()
      //     }, 8000)
      //   }
      // }
    }
  })

  const showModal = (delay) => {
    setTimeout((delay) => {
      window._klOnsite = window._klOnsite || []
      window._klOnsite.push(['openForm', window.newsletter.modalId])
    }, delay)
  }

  const cookieHiddenModal = getCookie('hidden_klaviyo_modal')

  window.addEventListener('PandectesEvent_OnHide', () => {
    if (cookieHiddenModal) {
      return
    }
    showModal(1000)
  })
}
